module.exports = __webpack_public_path__ + "static/media/chukuliucheng61.f2d27ab3.png";